import { render } from "./AcceptanceTermComponent.vue?vue&type=template&id=637e9694&ts=true"
import script from "./AcceptanceTermComponent.vue?vue&type=script&lang=ts"
export * from "./AcceptanceTermComponent.vue?vue&type=script&lang=ts"

import "./AcceptanceTermComponent.vue?vue&type=style&index=0&id=637e9694&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__